import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/icon-arrow-down.png'


const _withScopeId = n => (_pushScopeId("data-v-d2348450"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "holder" }, null, -1))
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "collapse-content" }
const _hoisted_4 = ["innerHTML"]

export interface IProps {
    title?: string;
    content?: string;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    content: null
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  const _component_AppCollapse = _resolveComponent("AppCollapse")!

  return (_openBlock(), _createBlock(_component_AppCollapse, { title: "text" }, {
    trigger: _withCtx(({ visible }) => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("img", {
        src: _imports_0,
        class: _normalizeClass({ active: visible })
      }, null, 2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("div", { innerHTML: __props.content }, null, 8, _hoisted_4)
        ])
      ])
    ]),
    _: 3
  }))
}
}

})